import { useEffect, useState } from 'react';
import { Button, Snackbar, Alert, Box, Typography } from '@mui/material';
import { Refresh, GetApp } from '@mui/icons-material';

const ServiceWorkerRegistration = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [reloadTriggered, setReloadTriggered] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Регистрируем Service Worker
      navigator.serviceWorker.register('/sw.js')
        .then((reg) => {
          console.log('Service Worker registered:', reg);

          // Проверяем наличие обновлений
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (newWorker) {
              setWaitingWorker(newWorker);
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Новый Service Worker установлен и готов к активации
                  setUpdateAvailable(true);
                }
              });
            }
          });
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });

      // Слушаем сообщения от Service Worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'RELOAD') {
          window.location.reload();
        }
      });

      // Перезагружаем страницу после активации нового SW
      const onControllerChange = () => {
        if (reloadTriggered) return;
        setReloadTriggered(true);
        window.location.reload();
      };
      navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
      return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    }
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      // Отправляем сообщение Service Worker для активации
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      setUpdateAvailable(false);
    }
  };

  // Авто-обновление без участия пользователя
  useEffect(() => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  }, [waitingWorker]);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <>
      {updateAvailable && (
        <Snackbar
          open={updateAvailable}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          sx={{ mb: 2 }}
        >
          <Alert
            severity="info"
            action={
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleUpdate}
                  startIcon={<GetApp />}
                >
                  Обновить
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleReload}
                  startIcon={<Refresh />}
                >
                  Перезагрузить
                </Button>
              </Box>
            }
            sx={{ minWidth: 300 }}
          >
            <Typography variant="body2">
              Доступно обновление приложения
            </Typography>
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default ServiceWorkerRegistration;
